const dangerKeyword = [
  '急性脑内血肿',
  '挫裂伤',
  '急性蛛网膜下腔出血',
  '急性硬膜下血肿',
  '急性硬膜外血肿',
  '脑疝',
  '急性脑积水',
  '脑梗死',
  '脑出血',
  '脊柱骨折并长轴成角畸形',
  '椎骨粉碎性骨折硬膜囊受压',
  '爆裂性骨折',
  '气管异物',
  '支气管异物',
  '气胸',
  '液气胸',
  '肺栓塞',
  '肺梗死',
  '一侧肺不张',
  '急性肺水肿',
  '创伤性膈疝',
  '心包填塞',
  '纵隔摆动',
  '主动脉夹层动脉瘤',
  '食道异物',
  '消化道穿孔',
  '急性肠梗阻',
  '急性胆道梗阻',
  '急性出血坏死性胰腺炎',
  '腹腔脏器出血',
  '眼眶内异物',
  '眼眶及内容物破裂',
  '眼眶骨折',
  '颌面部骨折',
  '颅底骨折',
  '多发肋骨骨折并错位',
  '肺挫伤',
  '血气胸',
  '骨盆环骨折',
];

export { dangerKeyword };
